module.exports = __webpack_public_path__ + "media/src/img/pdf-icon-blue-fb29ac9b3e1fca042eecb52f3d86556b.svg";